import { css, keyframes } from 'styled-components';

import { ScrollAxis, TRAVEL_SHARE } from 'hooks/use-overflow-scroll';

const HOLD_SHARE = (1 - 2 * TRAVEL_SHARE) / 3;

const percent = (share: number) => `${Math.round(share * 100)}%`;

const TRANSLATE_BY_AXIS: Record<ScrollAxis, string> = {
  horizontal: 'translateX',
  vertical: 'translateY',
};

const scrollAlong = (axis: ScrollAxis) => {
  const translate = TRANSLATE_BY_AXIS[axis];

  return keyframes`
    0%, ${percent(HOLD_SHARE)} {
      transform: ${translate}(0);
    }
    ${percent(HOLD_SHARE + TRAVEL_SHARE)}, ${percent(2 * HOLD_SHARE + TRAVEL_SHARE)} {
      transform: ${translate}(calc(-1 * var(--scroll-distance)));
    }
    ${percent(2 * HOLD_SHARE + 2 * TRAVEL_SHARE)}, 100% {
      transform: ${translate}(0);
    }
  `;
};

const KEYFRAMES_BY_AXIS: Record<ScrollAxis, ReturnType<typeof keyframes>> = {
  horizontal: scrollAlong('horizontal'),
  vertical: scrollAlong('vertical'),
};

export const overflowScrollAnimation = (axis: ScrollAxis) => css`
  animation-name: ${KEYFRAMES_BY_AXIS[axis]};
  animation-timing-function: linear;
  animation-iteration-count: infinite;
`;
